export function currentPagePath(): string {
  const pathSplit = window.location.pathname !== undefined ? window.location.pathname.split('/') : [];
  const targetPath = pathSplit.length > 1 ? `/${pathSplit[1]}` : '';
  return targetPath;
}
